import {english} from '../languages/english';
import {french} from '../languages/french';
import {cuppa, log, val} from "../../cuppa/cuppa";
import {CuppaStorage} from "../../cuppa/cuppa.storage";

export class Language{
  static storage = {name:'LANGUAGE', store:CuppaStorage.LOCAL, defaultValue:null};
  static data = english;
  static languageList = [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
  ];
  static current = Language.languageList[0];

  // execute this method when app load to recover the stored language
  static async retrieveStoredLanguage(){
    let data = await CuppaStorage.getData(Language.storage);
    if(!data?.value) return;
    Language.change(data);
  }

  static change(lang){
    Language.current = lang;
    Language.data = english;
    if(Language.current?.value?.toLowerCase() == "fr") Language.data = french;
		CuppaStorage.setData({...Language.storage, data:Language.current}).then();
  }

  static value(key, format){
    if(!key) key = "";
    let data = Language.data[key];
    if(!data) data = Language.data[key.toLowerCase()];
    if(!data) data = Language.data[key.toUpperCase()];
    if(!data) data = Language.data[cuppa.replace(key.toLowerCase(), " ", "")];
    if(!data) data = Language.data[cuppa.camelize(key)];
    if(!data) data = key;

    if(format) format = format.toLowerCase();
    if(format == "capitalize") data = cuppa.capitalize(data);
    else if(format == "upper" || format == "uppercase") data = String(data).toUpperCase();
    else if(format == "lower" || format == "lowercase") data = String(data).toLowerCase();
    else if(format == "word") data = cuppa.capitaliseAllWords(data);
    return data;
  }
}
